import axios from "axios";
import { WEBSITE_NAME } from "../../constants/CompanyConstants";

export const sendExceptionToSlack = (message) => {
  if (process.env.REACT_APP_ENVIRONMENT === "local") return;
  let projectName = WEBSITE_NAME;
  if (process.env.REACT_APP_ENVIRONMENT !== "production") {
    projectName += " DEV";
  }
  axios
    .post("https://guardian.digitalkiss.nl/api/slack/exception", {
      project: projectName,
      message,
    })
    .catch((err) => console.log(err));
};
